import styled from 'styled-components';

export const HeaderRow = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
`;

export const TitleRow = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  border-bottom: solid 1px black;
`;

export const CareGiverBorder = styled.div`
  border-bottom: solid 1px black;
`;

export const HeaderTitle = styled.div`
  width: 20%;
  font-weight: bold;
  font-size: 12pt;
`;

export const InterventionTitle = styled.div`
  font-size: 11pt;
  font-style: italic;
  text-decoration: underline;
`;

export const HeaderDetail = styled.div`
  width: 20%;
  font-size: 10pt;
  padding: 0.2cm;
`;

export const InterventionDetail = styled.div`
  width: 100%;
  font-size: 10pt;
  padding: 0.2cm;
`;

export const CareGiverTableContainer = styled.div`
  width: 100%;
  margin-bottom: 3rem;
`;

export const HalfInterventionContainer = styled.div`
  width: 50%;
`;

export const InterventionsContainer = styled.div`
  width: 100%;
`;

export const InterventionsRow = styled.div`
  display: flex;
  flex-direction: row;
`;

export const NoBereavementsTextContainer = styled.div`
  width: 100%;
  text-align: center;
`;

export const NoBereavementText = styled.div`
  font-size: 10pt;
`;
